var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { TrayActionList, TrayActionListItem } from './TrayActionList.js';
import { TrayContext } from './TrayContext.js';
import { TrayHeader } from './TrayHeader.js';
export const Tray = (_a) => {
    var { children, open, onClose, className } = _a, rest = __rest(_a, ["children", "open", "onClose", "className"]);
    return (React.createElement(TrayContext.Provider, { value: {
            open,
            onClose,
        } },
        React.createElement(BackgroundProvider, { backgroundType: "surface" },
            React.createElement(Transition.Root, { appear: true, show: open, as: Fragment },
                React.createElement(Dialog, Object.assign({ as: "div", className: clsx('fixed z-10 inset-0', className), onClose: onClose }, rest),
                    React.createElement(Transition.Child, { as: Fragment, enter: "transition-opacity ease-linear duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "transition-opacity ease-linear duration-300", leaveFrom: "opacity-100", leaveTo: "opacity-0" },
                        React.createElement(Dialog.Overlay, { className: "fixed inset-0" },
                            React.createElement("div", { className: "absolute inset-0 bg-background-backdrop", onClick: onClose }))),
                    React.createElement("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen", "aria-hidden": "true" }, "\u200B"),
                    React.createElement(Transition.Child, { as: Fragment, enter: "transition ease-out duration-300", enterFrom: "opacity-0 translate-y-full", enterTo: "opacity-100 translate-y-0", leave: "transition ease-in duration-300", leaveFrom: "opacity-100 translate-y-0", leaveTo: "opacity-0 translate-y-full" },
                        React.createElement("div", { className: "absolute bottom-0 translate-y-full w-full transform" },
                            React.createElement("div", { className: "max-w-screen-sm mx-auto rounded-t-xl bg-surface text-content-subdued shadow-xl overflow-y-auto" }, children))))))));
};
const TrayContent = ({ children }) => (React.createElement("div", { className: "px-4 py-5 sm:p-6" }, children));
Tray.Header = TrayHeader;
Tray.Content = TrayContent;
Tray.ActionList = TrayActionList;
Tray.ActionListItem = TrayActionListItem;
//# sourceMappingURL=Tray.js.map